import React,{ Component } from 'react';
import {  Route,Switch ,Redirect} from 'react-router-dom'
import { authRef } from "../config/firebase";
import { connect } from 'react-redux'
import { estabaLogueado } from '../actions'

import Cuerpo 	from '../components/cuerpo'
import Responsabilidad 	from '../components/responsabilidad'
import HeaderNew   from '../containers/headerNew'
import Footer 	from '../components/footer'
import Home 	from '../containers/home'
import Contacto   from '../containers/contacto'
import ProductosLista 	from '../components/prodlista'
import ProductosListaDirect from '../components/prodlistadirect'
import Login   from '../containers/login'
import Registro   from '../containers/registro'
import Usuario   from '../containers/panel_usuario'
import Reset   from '../containers/reset'
import Perfil from '../containers/mis_datos'

//import Perfil from '../components/user_menu'
import Direcciones from '../containers/lista_direcciones'
import Pedidos from '../containers/lista_pedidos'
import Pedido from '../containers/pedido_detalle'
import Direccion from '../containers/direccion'

import Carro from '../containers/carro'
import SendPedido from '../containers/envia_pedido'
import Custom from '../containers/custom'
import CustomMod from '../containers/customod'

import Admin          from '../containers/admin'
import AdminProds     from '../containers/admin_prods'
import AdminProd      from '../containers/admin_prod'
import AdminProdForm from '../containers/admin_prod_form'
import AdminOpcionForm from "../containers/admin_opcion_form"
import AdminPedidos   from '../containers/admin_pedidos'
import AdminPedido    from '../containers/admin_pedido'
import AdminMetodos from '../containers/admin_metodos'
import AdminMetodo from '../containers/admin_metodo'
import AdminRubros from '../containers/admin_rubros'
import AdminCategorias from '../containers/admin_categorias'
import AdminRubro from '../containers/rubro_form'
import AdminCategoria from '../containers/categoria_form'
import AdminPrecio from "../containers/precio_form";
import AdminGrupo from "../containers/grupo_form";
import Resp   from '../containers/resp'

//{this.props.match.url + '/perfil'}
class App extends Component{
  
  constructor(props) {
    super(props);

    authRef.onAuthStateChanged(this.chkLog);
    this.chkLog = this.chkLog.bind(this)
  }

  componentDidMount() {
    //console.log(this.props)
    if(this.props.location.search){
      //console.log(this.props.location.search)
    }
  }

  chkLog = (user)=> {
      if (user) {
        this.props.estabaLogueado(user)
      } else {
        console.log("SE DESLOGUEO")
      }
  }

  render(){
    return (
      <div className="container-fluid p-0">
        <HeaderNew />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/responsabilidad" component={Responsabilidad} />
          <Route exact path="/pulseras_tyvek" render={(props) => (<ProductosListaDirect rubro="1" categoria="1" {...props} />)}/>
          <Route exact path="/pulseras_tyvek_rfid" render={(props) => (<ProductosListaDirect rubro="1" categoria="14" {...props} />)}/>
          <Route exact path="/pulseras_plasticas" render={(props) => (<ProductosListaDirect rubro="1" categoria="2" {...props} />)}/>
          <Route exact path="/pulseras_plasticas_ancho" render={(props) => (<ProductosListaDirect rubro="1" categoria="15" {...props} />)}/>
          <Route exact path="/pulseras_plasticas_rfid" render={(props) => (<ProductosListaDirect rubro="1" categoria="13" {...props} />)}/>
          <Route exact path="/pulseras_glitter" render={(props) => (<ProductosListaDirect rubro="1" categoria="3" {...props} />)}/>
          <Route exact path="/pulseras_vinilo" render={(props) => (<ProductosListaDirect rubro="1" categoria="26" {...props} />)}/>
          <Route exact path="/pulseras_termicas" render={(props) => (<ProductosListaDirect rubro="1" categoria="4" {...props} />)}/>
          <Route exact path="/pulseras_termicas_rfid" render={(props) => (<ProductosListaDirect rubro="1" categoria="21" {...props} />)}/>
          <Route exact path="/entradas_cartulina_118grs" render={(props) => (<ProductosListaDirect rubro="3" categoria="5" {...props} />)}/>
          <Route exact path="/entradas_cartulina_118grs_con_holograma_seguridad" render={(props) => (<ProductosListaDirect rubro="3" categoria="19"  {...props} />)} />
          <Route exact path="/entradas_cartulina_termica_170grs" render={(props) => (<ProductosListaDirect rubro="3" categoria="12" {...props} />)}/>
          <Route exact path="/entradas_cartulina_termica_190grs_con_color_central" render={(props) => (<ProductosListaDirect rubro="3" categoria="20"  {...props} />)} />
          <Route exact path="/pecheras_pecheras_tyvek" render={(props) => (<ProductosListaDirect rubro="2" categoria="7" {...props} />)}/>
          <Route exact path="/tarjetas_plasticas" render={(props) => (<ProductosListaDirect rubro="4" categoria="8" {...props} />)}/>
          <Route exact path="/tarjetas_plasticas_id" render={(props) => (<ProductosListaDirect rubro="4" categoria="22" {...props} />)}/>
          <Route exact path="/tarjetas_plasticas_acceso_rfid" render={(props) => (<ProductosListaDirect rubro="4" categoria="23" {...props} />)}/>
          <Route exact path="/tarjetas_plasticas_acceso_rfid_light" render={(props) => (<ProductosListaDirect rubro="4" categoria="24" {...props} />)}/>
          <Route exact path="/credenciales_plasticas" render={(props) => (<ProductosListaDirect rubro="5" categoria="10" {...props} />)}/>
          <Route exact path="/credenciales_plasticas_rfid" render={(props) => (<ProductosListaDirect rubro="5" categoria="25" {...props} />)}/>
          <Route exact path="/cinta_portacredencial" render={(props) => (<ProductosListaDirect rubro="6" categoria="16" {...props} />)}/>


          <Route
            path="/productos/:rubro/:categoria"
            component={ProductosLista}
          />

          <Route path="/producto/:id" component={Cuerpo} />

          <Route path="/success" component={Resp} resp={1} />
          <Route path="/standby" component={Resp} resp={2} />
          <Route path="/fail" component={Resp} resp={3} />
          <Route path="/aconfirmar" component={Resp} resp={2} />

          <Route exact path="/contacto" component={Contacto} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/registro" component={Registro} />
          <Route exact path="/usuario" component={Usuario} />
          <Route exact path="/reset" component={Reset} />

          <Route exact path="/custom" component={Custom} />
          <Route exact path="/customizar/:id" component={CustomMod} />

          <Route exact path="/carro" component={Carro} />

          <Route exact path="/usuario/perfil" component={Perfil} />
          <Route path={"/usuario/direcciones"} component={Direcciones} />
          <Route path={"/usuario/direccion"} component={Direccion} />
          <Route
            path={"/usuario/direccion/:id_direccion"}
            component={Direccion}
          />

          <PrivateRoute
            path={"/usuario/pedidos"}
            component={Pedidos}
            u={this.props.usuario.user}
          />
          <PrivateRoute
            path={"/usuario/pedido/:id_pedido"}
            component={Pedido}
            u={this.props.usuario.user}
          />
          <PrivateRoute
            path="/enviapedido"
            exact
            component={SendPedido}
            u={this.props.usuario.user}
          />

          <PrivateRoute
            path="/admin"
            exact
            component={Admin}
            u={this.props.usuario.user}
          />
          <PrivateRoute
            path="/admin/pedidos"
            exact
            component={AdminPedidos}
            u={this.props.usuario.user}
          />
          <PrivateRoute
            path="/admin/pedido/:id"
            exact
            component={AdminPedido}
            u={this.props.usuario.user}
          />
          <PrivateRoute
            path="/admin/productos"
            exact
            component={AdminProds}
            u={this.props.usuario.user}
          />
          <PrivateRoute
            path="/admin/producto/:id"
            exact
            component={AdminProd}
            u={this.props.usuario.user}
          />
          <PrivateRoute
            path="/admin/producto_form/:id?"
            exact
            component={AdminProdForm}
            u={this.props.usuario.user}
          />
          <PrivateRoute
            path="/admin/opcion/:cat?/:id?"
            exact
            component={AdminOpcionForm}
            u={this.props.usuario.user}
          />
          <PrivateRoute
            path="/admin/metodos"
            exact
            component={AdminMetodos}
            u={this.props.usuario.user}
          />
          <PrivateRoute
            path="/admin/metodo/:id?"
            component={AdminMetodo}
            u={this.props.usuario.user}
          />
          <PrivateRoute
            path="/admin/precio/:id_producto"
            exact
            component={AdminPrecio}
            u={this.props.usuario.user}
          />
          <PrivateRoute
            path="/admin/rubros"
            exact
            component={AdminRubros}
            u={this.props.usuario.user}
          />
          <PrivateRoute
            path="/admin/rubro/:id?"
            component={AdminRubro}
            u={this.props.usuario.user}
          />
          <PrivateRoute
            path="/admin/categorias"
            exact
            component={AdminCategorias}
            u={this.props.usuario.user}
          />
          <PrivateRoute
            path="/admin/categoria/:id?"
            exact
            component={AdminCategoria}
            u={this.props.usuario.user}
          />
          <PrivateRoute
            path="/admin/grupo/:id?"
            exact
            component={AdminGrupo}
            u={this.props.usuario.user}
          />
        </Switch>
        <Footer />
      </div>
    );
  }

};

const PrivateRoute = ({ u,component: Component, ...rest }) => (
  <Route
    {...rest}
    render={ props =>
      u   ? (
        <Component {...props} />
      ) : (
        <Redirect to={{ pathname: "/", state: { from: props.location } }} />
      )
    }
  />
);

const mapDispatchToProps = dispatch => {
  return {
    estabaLogueado: (user) => {
      dispatch(estabaLogueado(user))
    }
  }
}

const mapStateToProps = state => {
  return {
      usuario: state.usuario
    }
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App)




// WEBPACK FOOTER //
// ./src/components/App.js